<cm-sidebar-layout>
    <cm-item-filters cm-filters>
        @if (permission.$to().read.menu("filterByOrganizationOnTagsPage")) {
            <cm-tag-search-filter></cm-tag-search-filter>
        } @else {
            <cm-search-filter></cm-search-filter>
        }
        <cm-checkboxes-filter label="Type" name="tagType" [options]="$tagTypes()"></cm-checkboxes-filter>
    </cm-item-filters>
    <cm-tags-table></cm-tags-table>
</cm-sidebar-layout>
<router-outlet></router-outlet>
